import { Component, ViewChild, OnInit } from '@angular/core';
import { Events, NavController, Tabs } from 'ionic-angular';
import { SearchTabPage } from '../searchtabpage/searchtabpage';
import { SavingsProfilePage } from '../savingsprofile/savingsprofile';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { SearchDisplayCheck } from '../../../provider/searchVisibility';

/**
 * Generated class for the ParenttabsPage tabs.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'search-tabs',
  templateUrl: 'searchtabs.html'
})
export class SearchTabs implements OnInit {
  @ViewChild('searchTabs') tabRef: Tabs;

  tab1params = {
    user1: 'admin',
    user2: 'ionic'
  };

  tab2params = {
    user1: 'admin2',
    user2: 'ionic2'
  };

  tabs = [
    { title: 'Search', root: SearchTabPage, icon: 'calendar', params: this.tab1params },
    { title: 'Savings profile', root: SavingsProfilePage, icon: 'contacts', params: this.tab2params },
  ];

  tabSegment = 'Search';
  tabType;
  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    private searchVisibleData: SearchDisplayCheck,
    public events: Events) { 
      this.tabType = 'Search';
    }

  ngAfterViewInit() {
    // this.superTabs.enableTabsSwipe(false);
    // this.tabRef.select(0);
  }

  swipeEvent(e) {
    console.log('swiped');
  }

  selectedSegment(name) {
    this.tabSegment = name;
  }

  ngOnInit() {
   // this.tabRef.select(0);
  }

  ionViewDidEnter() {
    // this.tabRef.select(0);
   }


  closeSearch(event) {
    this.searchVisibleData.changeVisibility(false);
  }
  dismiss() {
    this.viewCtrl.dismiss();
  }

  onSearch() {
    // this.viewCtrl.dismiss(false);
    // this.messageEvent.emit(true);
    this.viewCtrl.dismiss();
  }

  ngOnDestroy() {
    console.log('Search tabs ondestroy');
    this.tabs = [];

  }
}
